import * as clienteActions from './clienteActions';

export const INITIAL_STATE = {
  clientes: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case clienteActions.SET_CLIENTES:
      return { ...state, clientes: action.payload };

    default:
      return state;
  }
};
